"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_exports = {};
__export(create_exports, {
  activeAnywhere: () => activeAnywhere,
  adminAnywhere: () => adminAnywhere,
  always: () => always,
  and: () => and,
  canGrantQualification: () => canGrantQualification,
  canGrantRole: () => canGrantRole,
  canGrantRoles: () => canGrantRoles,
  cond: () => cond,
  globalAdmin: () => globalAdmin,
  hasAccount: () => hasAccount,
  hasQualification: () => hasQualification,
  hasRole: () => hasRole,
  hasRoles: () => hasRoles,
  hasUserId: () => hasUserId,
  named: () => named,
  never: () => never,
  or: () => or,
  projectApprover: () => projectApprover,
  projectCoordinator: () => projectCoordinator,
  projectMember: () => projectMember,
  projectSurveyor: () => projectSurveyor,
  superuser: () => superuser,
  teamApprover: () => teamApprover,
  teamCoordinator: () => teamCoordinator,
  teamMember: () => teamMember,
  teamSurveyor: () => teamSurveyor,
  whenProjectHasTeam: () => whenProjectHasTeam,
  workspaceActive: () => workspaceActive,
  workspaceAdmin: () => workspaceAdmin,
  workspaceFullAccess: () => workspaceFullAccess,
  workspaceOwner: () => workspaceOwner,
  workspaceReadOnlyAccess: () => workspaceReadOnlyAccess
});
module.exports = __toCommonJS(create_exports);
var import_fp = require("@cartographerio/fp");
var import_guard = require("@cartographerio/guard");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
const always = { type: "Always" };
function never(reason) {
  return {
    type: "Never",
    reason
  };
}
function and(...args) {
  return { type: "And", args };
}
function or(...args) {
  return { type: "Or", args };
}
function cond(value, func, orElse) {
  return value != null ? func(value) : orElse;
}
function hasRole(role) {
  return {
    type: "HasRole",
    role
  };
}
function hasQualification(role) {
  return {
    type: "HasQualification",
    role
  };
}
function hasRoles(roles, qualificationRoles, fallback) {
  return roles.length + qualificationRoles.length > 0 ? and(...roles.map(hasRole), ...qualificationRoles.map(hasQualification)) : fallback();
}
function canGrantRole(role) {
  return {
    type: "CanGrantRole",
    role
  };
}
function canGrantQualification(role) {
  return {
    type: "CanGrantQualification",
    role
  };
}
function canGrantRoles(roles, qualificationRoles, fallback) {
  return roles.length + qualificationRoles.length > 0 ? and(...roles.map(canGrantRole), ...qualificationRoles.map(canGrantQualification)) : fallback();
}
const hasAccount = {
  type: "HasAccount"
};
function hasUserId(userId) {
  return {
    type: "HasUserId",
    userId
  };
}
const activeAnywhere = {
  type: "InAnyWorkspace",
  name: "Active"
};
const adminAnywhere = {
  type: "InAnyWorkspace",
  name: "Admin"
};
function named(name, check) {
  return {
    type: "Named",
    name: `[Client] ${name}`,
    check
  };
}
function workspaceReadOnlyAccess(workspaceId) {
  return or(globalAdmin, {
    type: "WorkspaceAccess",
    workspaceId,
    minAccess: "ReadOnly"
  });
}
function workspaceFullAccess(workspaceId) {
  return or(globalAdmin, {
    type: "WorkspaceAccess",
    workspaceId,
    minAccess: "Full"
  });
}
const superuser = hasRole(import_types.superuserRole);
const globalAdmin = hasRole(import_types.globalAdminRole);
function workspaceActive(workspaceId) {
  return or(globalAdmin, hasRole((0, import_types.workspaceActiveRole)(workspaceId)));
}
function workspaceAdmin(workspaceId) {
  return or(globalAdmin, hasRole((0, import_types.workspaceAdminRole)(workspaceId)));
}
function workspaceOwner(workspaceId) {
  return hasRole((0, import_types.workspaceOwnerRole)(workspaceId));
}
function projectMember(projectId, workspaceId, teamIds) {
  return projectRoleCheck("Member", projectId, workspaceId, teamIds);
}
function projectSurveyor(model, projectId, workspaceId, teamIds) {
  switch (model) {
    case "Default":
    case "SurveyorSensitive":
    case "TeamSensitive":
      return projectRoleCheck("Surveyor", projectId, workspaceId, teamIds);
    case "CoordinatorOnly":
      return projectRoleCheck("Coordinator", projectId, workspaceId, teamIds);
    default:
      return (0, import_util.checkExhausted)(model);
  }
}
function projectApprover(model, projectId, workspaceId, teamIds) {
  switch (model) {
    case "Default":
    case "SurveyorSensitive":
    case "TeamSensitive":
      return projectRoleCheck("Approver", projectId, workspaceId, teamIds);
    case "CoordinatorOnly":
      return projectRoleCheck("Coordinator", projectId, workspaceId, teamIds);
    default:
      return (0, import_util.checkExhausted)(model);
  }
}
function projectCoordinator(projectId, workspaceId, teamIds) {
  return projectRoleCheck("Coordinator", projectId, workspaceId, teamIds);
}
function projectRoleCheck(role, projectId, workspaceId, teamIds) {
  teamIds = (0, import_guard.isArray)(teamIds) ? teamIds : import_fp.Option.wrap(teamIds).toArray();
  return or(
    workspaceAdmin(workspaceId),
    and(
      workspaceActive(workspaceId),
      or(hasRole((0, import_types.projectRole)(role, projectId)), ...teamIds.map((teamId) => hasRole((0, import_types.teamRole)(role, teamId))))
    )
  );
}
function teamMember(teamId, workspaceId, projectIds) {
  return teamRoleCheck("Member", teamId, workspaceId, projectIds);
}
function teamSurveyor(model, teamId, workspaceId, projectIds) {
  switch (model) {
    case "Default":
    case "SurveyorSensitive":
    case "TeamSensitive":
      return teamRoleCheck("Surveyor", teamId, workspaceId, projectIds);
    case "CoordinatorOnly":
      return teamRoleCheck("Coordinator", teamId, workspaceId, projectIds);
    default:
      return (0, import_util.checkExhausted)(model);
  }
}
function teamApprover(model, teamId, workspaceId, projectIds) {
  switch (model) {
    case "Default":
    case "SurveyorSensitive":
    case "TeamSensitive":
      return teamRoleCheck("Approver", teamId, workspaceId, projectIds);
    case "CoordinatorOnly":
      return teamRoleCheck("Coordinator", teamId, workspaceId, projectIds);
    default:
      return (0, import_util.checkExhausted)(model);
  }
}
function teamCoordinator(teamId, workspaceId, projectIds) {
  return teamRoleCheck("Coordinator", teamId, workspaceId, projectIds);
}
function teamRoleCheck(role, teamId, workspaceId, projectIds) {
  projectIds = (0, import_guard.isArray)(projectIds) ? projectIds : import_fp.Option.wrap(projectIds).toArray();
  return or(
    workspaceAdmin(workspaceId),
    and(
      workspaceActive(workspaceId),
      or(hasRole((0, import_types.teamRole)(role, teamId)), ...projectIds.map((projectId) => hasRole((0, import_types.projectRole)(role, projectId))))
    )
  );
}
function whenProjectHasTeam(project, teamId, subCheck) {
  return teamId == null ? never("No team specified") : project.teamIds.includes(teamId) ? subCheck(teamId) : never(`Project ${project.id} does not contain team ${teamId}`);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  activeAnywhere,
  adminAnywhere,
  always,
  and,
  canGrantQualification,
  canGrantRole,
  canGrantRoles,
  cond,
  globalAdmin,
  hasAccount,
  hasQualification,
  hasRole,
  hasRoles,
  hasUserId,
  named,
  never,
  or,
  projectApprover,
  projectCoordinator,
  projectMember,
  projectSurveyor,
  superuser,
  teamApprover,
  teamCoordinator,
  teamMember,
  teamSurveyor,
  whenProjectHasTeam,
  workspaceActive,
  workspaceAdmin,
  workspaceFullAccess,
  workspaceOwner,
  workspaceReadOnlyAccess
});
//# sourceMappingURL=create.js.map
